<template>
  <div class="outer-wrapper">
      <div class="title">
        <p>原材料管理</p>
    </div>
    <Tabs>
      <TabPane label="全部原材料" icon="logo-buffer">
        <query-list
          :columnsFormatData="columnsFormatData"
          :askData="askData"
          :refreshData="update_count"
          main_width="1280px"
        ></query-list>
      </TabPane>
      <Button @click="openModal('newCreate')" slot="extra" type="primary">新增材料</Button>
    </Tabs>
    <Modal
      v-model="modalValue.newCreate"
      :width="600"
      :mask-closable="false"
      :closable="false"
    >
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>新建材料</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="cr-form">
            <tr>
              <td>入库编号：</td>
              <td>
                <input
                  type="text"
                  placeholder="例：IT01"
                  v-model="newItem.matnum"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>牌号：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="newItem.grade"
                  style="width:200px;"
                  list="grade"
                  @change="gradeChange"
                />
                <datalist id="grade">
                    <option :value="ele.value" v-for="ele in gradeList" :key="ele.value+'grade'"/>
                </datalist>
              </td>
            </tr>
            <tr>
              <td>标准：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="newItem.standard"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>外径：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="newItem.diameter"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>公称厚度：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="newItem.thickness"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>炉批号：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="newItem.stovebatch"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>经销商：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="newItem.seller"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>生产厂家：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="newItem.producer"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>质量证明书编号：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="newItem.certificate"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>数量：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model.number="newItem.matamount"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>供货状态：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="newItem.status"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>入库日期：</td>
              <td>
                <input
                  type="date"
                  placeholder=""
                  v-model="newItem.takedate"
                  style="width:200px;"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="newCreateSubmit('newCreate')" :disabled="shellCreateValid" >提交</Button>
        <Button size="large" @click="closeModal('newCreate')" >取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import queryList from "@/components/Common/QueryList.vue";
let authData = JSON.parse(localStorage.getItem("authData"));
let userToken = localStorage.getItem("current_user_token");
//import shellExpand from "./ShellExpand.vue";

function itemValue(){
    return {
        matnum:"",
        grade:"",
        diameter:"",
        thickness:"",
        stovebatch:"",
        seller:"",
        producer:"",
        certificate:"",
        matamount:1,
        takedate:null,
        standard:"",
        status:"",
    };
}

export default {
  name: "material",
  props: [],
  components: {
    queryList
  },
  data() {
    return {
      op_name: this.$options.name,
      askData: "matList",
      update_count: 0,
      modalValue:{
          newCreate:false,
      },
      newItem:itemValue(),
      gradeList:[
            {value:'35CrMo'},
            {value:'20'},
            {value:'06Cr19Ni10'},
        ],
      columnsFormatData: [
        /*{
            type: 'expand',
            width: 30,
            render: (h, params) => {
                return h(shellExpand, {
                    props: {
                        row: params.row
                    }
                })
            }
        },*/
        {
          title: "入库编号",
          key: "matnum",
          width: 85,
          align: "center"
        },
        {
          title: "牌号",
          key: "grade",
          width: 110,
          align: "center"
        },
        {
          title: "规格(mm)",
          width: 95,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "p",
                {
                  style: {},
                },
                'Φ'+params.row.diameter+'×'+params.row.thickness
              )
            ]);
          }
        },
        {
          title: "炉批号",
          key: "stovebatch",
          width: 150,
          align: "center"
        },
        {
          title: "经销商",
          key: "seller",
          align: "center"
        },
        {
          title: "生产厂家",
          key: "producer",
          align: "center"
        },
        {
          title: "质量证明书编号",
          key: "certificate",
          width: 130,
          align: "center"
        },
        {
          title: "数量(支)",
          key: "matamount",
          width: 85,
          align: "center"
        },
        {
          title: "入库日期",
          key: "takedate",
          width: 100,
          align: "center"
        },
        {
          title: "操作",
          align: "center",
          width: 150,
          render: (h, params) => {
            return h("div", [
              /*h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { marginRight: "10px", color: "green" },
                  on: {
                    click: () => {
                      this.modalSwicth = true;
                      this.formItemAlter.id = params.row.id;
                      this.formItemAlter.title =
                        params.row.title;
                      this.formItemAlter.author = params.row.author;
                      this.formItemAlter.paperDate =
                        params.row.paper_date;
                      this.formItemAlter.faPeriod =
                        params.row.fa_period;
                      this.formItemAlter.faType =
                        params.row.fa_type;
                      this.formItemAlter.faDescription = params.row.fa_description;
                      this.formItemAlter.material = params.row.material;
                      this.formItemAlter.craft = params.row.craft;
                      this.formItemAlter.reason= params.row.reason;
                    }
                  }
                },
                "修改"
              ),*/
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { color: "red",marginRight:'5px' },
                  on: {
                    click: () => {
                      this.confirmBox(params.row);
                    }
                  }
                },
                "删除"
              ),
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { color: "green" },
                  on: {
                    click: () => {
                      window.open('/archive/materialCheck/'+params.row.matnum,'_blank');
                    }
                  }
                },
                "验收单"
              ),
            ]);
          }
        }
        
      ]
    };
  },
  computed:{
    shellCreateValid:function(){
      if(this.newItem.matnum!==""&&
         this.newItem.grade!==""&&
        this.newItem.diameter!==""&&
        this.newItem.thickness!==""&&
        this.newItem.stovebatch!==""&&
        this.newItem.seller!==""&&
        this.newItem.producer!==""&&
        this.newItem.certificate!==""&&
        this.newItem.matamount!==""&&
        this.newItem.takedate
         ){
           return false;
         }else{
           return true;
         }
    }

  },
  methods: {
    linkTo(url) {
      window.open(this.$fileUrlFac(url, authData.sfileRight));
    },
    openModal(value){
        this.modalValue[value] = true;
    },
    closeModal(value){
        this.modalValue[value] = false;
    },
    confirmBox(value) {
      this.$Modal.confirm({
        title: "确认删除：",
        content:
          "<p>" +
          "材料：" +
          value.matnum +          
          "</p>",
        onOk: () => {
          this.recordFormatDel(value.matnum);
        },
        onCancel: () => {}
      });
    },
    recordFormatDel(id) {
      this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: "delMaterial",
          id: id
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.$Message.success("删除成功！");
            this.update_count++;
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    newCreateSubmit(value){
        this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: "createMaterial",
          item: this.newItem   
        })
        .then(response => {
          if (response.data.stat == "ok") {
            this.$Message.success("新建成功！");
            this.closeModal(value);
            this.update_count++;
          } else {
            this.closeModal(value);
            this.$Message.error(response.data.data.info);
          }
        }).catch(error=>{
            this.$Message.error("网络连接有误！"+error);
        });
    },
    gradeChange(){
      if(this.newItem.grade==='20'){
        this.newItem.standard = "GB/T 6479-2013《高压化肥设备用无缝钢管》";
        this.newItem.status = "热轧";
      }else if(this.newItem.grade === '35CrMo'){
        this.newItem.standard = "GB/T 18248-2008《气瓶用无缝钢管》";
        this.newItem.status = "热轧";
      }else{
        this.newItem.standard = "GB/T 14976-2012《输送流体用不锈钢无缝钢管》";
        this.newItem.status = "固溶";
      }
    },
  }
};
</script>
<style scoped>
.outer-wrapper{
    width:1280px;
    margin:0 auto;
}
.title{
  text-align: center;
  margin:10px auto;
  font-size:20px;

}
.cr-form{
    width:100%;
    border-collapse: collapse;
}

.cr-form td{
    height:45px;
}

.cr-form td:first-child{
    text-align: right;
}

.cr-form input{
    padding: 0 10px;
    outline: none;
    height:30px;
    border-radius: 2px;
    border:1px solid #aaa;
}
</style>